// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__oT8sb","inner":"Footer_inner__3y3ey","nextIcon":"Footer_nextIcon__RKBhF","innerLeft":"Footer_innerLeft__3oyUx"};